/**
 * Persist a receipt image on the device (Downloads / Files).
 * Call from a user gesture (button click) before awaiting network I/O
 * so mobile browsers still allow the download.
 */

function receiptFilename(blob: Blob): string {
  const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
  if (blob.type === "application/pdf") return `receipt-${stamp}.pdf`;
  const ext = blob.type === "image/png" ? "png" : "jpg";
  return `receipt-${stamp}.${ext}`;
}

/** Trigger a file download into the phone's Downloads / Files app. */
export function saveReceiptLocally(blob: Blob): void {
  const filename = receiptFilename(blob);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 4_000);
}
